const $ = require('lib/jquery')
require('plugin/jstorage')


const Storage = {

    get(key, defaultValue) {
        return $.jStorage.get(key, defaultValue)
    },
    set(key, value, options) {
        return $.jStorage.set(key, value, options)
    },
    index() {
        return $.jStorage.index()
    },
    flush() {
        return $.jStorage.flush()
    },
    deleteKey(key) {
        return $.jStorage.deleteKey(key)
    },
}

module.exports = Storage
